var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.deliveryTimeText)?_c('div',{staticClass:"tp-text-body"},[_vm._v(" "+_vm._s(_vm.deliveryTimeText)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }